import React, { useState } from 'react';
import { Grid, TextField, Button, MenuItem, Alert, CircularProgress, Box } from '@mui/material';
import axios from 'axios';

const ClientDetails = ({ client }) => {
    const [formData, setFormData] = useState({
        _id: client._id || '',
        email: client.email || '',
        MyFirstName: client.MyFirstName || '',
        MyFullName: client.MyFullName || '',
        MyLinkedIn: client.MyLinkedIn || '',
        MyPhone: client.MyPhone || '',
        Status: client.Status || '',
        Partner: client.Partner || '',
        DeliveryLead: client.DeliveryLead || '',
        PrimaryPOC: client.PrimaryPOC || '',
        TotalCredits: client.TotalCredits || '',
        Cohort: client.Cohort || '',
        Locations: client.Locations || '',
    });

    const [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setSuccessMessage('');
        setErrorMessage('');
        console.log("Submitting:", formData);

        try {
            const response = await axios.post('/api/execedge/updateClient', { ...formData });

            if (response.status === 200) {
                setSuccessMessage('Client details updated successfully!');
            } else {
                setErrorMessage('Failed to update client details.');
            }
        } catch (error) {
            console.error('Error updating client details:', error);
            setErrorMessage('An error occurred: ' + (error.response?.data?.message || error.message));
        } finally {
            setLoading(false);
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
                {successMessage && (
                    <Grid item xs={12}>
                        <Alert severity="success">{successMessage}</Alert>
                    </Grid>
                )}
                {errorMessage && (
                    <Grid item xs={12}>
                        <Alert severity="error">{errorMessage}</Alert>
                    </Grid>
                )}
                {/* Form fields */}
                <Grid item xs={12} sm={6}>
                    <TextField fullWidth label="Email" type="email" name="email" value={formData.email} onChange={handleChange} required />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField fullWidth label="First Name" type="text" name="MyFirstName" value={formData.MyFirstName} onChange={handleChange} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField fullWidth label="Full Name" type="text" name="MyFullName" value={formData.MyFullName} onChange={handleChange} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField fullWidth label="LinkedIn" type="url" name="MyLinkedIn" value={formData.MyLinkedIn} onChange={handleChange} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField fullWidth label="Phone" type="text" name="MyPhone" value={formData.MyPhone} onChange={handleChange} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        select
                        label="Status"
                        name="Status"
                        value={formData.Status}
                        onChange={handleChange}
                    >
                        <MenuItem value="">Select Status</MenuItem>
                        <MenuItem value="Active">Active</MenuItem>
                        <MenuItem value="Inactive">Inactive</MenuItem>
                    </TextField>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField fullWidth label="Partner" type="text" name="Partner" value={formData.Partner} onChange={handleChange} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField fullWidth label="Delivery Lead" type="text" name="DeliveryLead" value={formData.DeliveryLead} onChange={handleChange} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField fullWidth label="Primary POC" type="text" name="PrimaryPOC" value={formData.PrimaryPOC} onChange={handleChange} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="Total Credits"
                        type="number"
                        name="TotalCredits"
                        value={formData.TotalCredits}
                        onChange={handleChange}
                        inputProps={{ min: 0, max: 1000 }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField fullWidth label="Cohort" type="text" name="Cohort" value={formData.Cohort} onChange={handleChange} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="Locations"
                        type="text"
                        name="Locations"
                        value={formData.Locations}
                        onChange={handleChange}
                        placeholder="Enter locations separated by commas"
                    />
                </Grid>

                <Grid item xs={12}>
                    <Box display="flex" justifyContent="center">
                        <Button type="submit" variant="contained" color="primary" fullWidth disabled={loading}>
                            {loading ? <CircularProgress size={24} /> : 'Submit'}
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </form>
    );
};

export default ClientDetails;
